import { render, staticRenderFns } from "./ChatX4.vue?vue&type=template&id=8b0df70e&"
import script from "./ChatX4.vue?vue&type=script&lang=js&"
export * from "./ChatX4.vue?vue&type=script&lang=js&"
import style0 from "./ChatX4.vue?vue&type=style&index=0&id=8b0df70e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports